export default __webpack_public_path__ + "media/images/loader-af349b4c6a412c9a74d59967a1bce20b.gif";